module.exports = __webpack_public_path__ + "img/brume_md.ec39279.webp";